import Vue from 'vue'

export default {
  methods: {

    adjustPosition(containerEl, popoverEl, x, y) {
      let containerPadding = 10
      let popoverMargin = 15
      let editorWidth = containerEl.offsetWidth
      let editorHeight = containerEl.offsetHeight
      let popoverWidth = popoverEl.offsetWidth
      let popoverHeight = popoverEl.offsetHeight

      x = Math.round(x)
      y = Math.round(y)

      // Default to underneath the position + center
      var targetX = x-popoverWidth/2
      var targetY = y+popoverMargin

      targetX = Math.max(containerPadding, targetX)
      targetY = Math.max(containerPadding, targetY)
      targetX = Math.min(editorWidth-popoverWidth-containerPadding, targetX)
      targetY = Math.min(editorHeight-popoverHeight-containerPadding, targetY)

      // If the popover now covers the position, move it to another position
      if(targetX < x && targetX+popoverWidth > x && targetY < y && targetY+popoverHeight > y) {
        if(targetX < editorWidth/4) {
          // Right pos
          targetX = x + popoverMargin
          targetY = y + popoverHeight/2
        }
        else if(targetX > editorWidth/4*3) {
          // Left pos
          targetX = x - popoverMargin - popoverWidth
          targetY = y + popoverHeight/2
        } else if(targetY > editorHeight/4*3) {
          // Top pos
          targetX = x-popoverWidth/2
          targetY = y-popoverHeight-popoverMargin
        }            
      }

      // Clamp again
      targetX = Math.max(containerPadding, targetX)
      targetY = Math.max(containerPadding, targetY)
      targetX = Math.min(editorWidth-popoverWidth-containerPadding, targetX)
      targetY = Math.min(editorHeight-popoverHeight-containerPadding, targetY)

      popoverEl.style.left = `${(targetX)}px`
      popoverEl.style.top = `${targetY}px`
    },

    adjustCenterToPosition(containerEl, popoverEl, x, y) {
      let popoverWidth = popoverEl.offsetWidth
      let popoverHeight = popoverEl.offsetHeight

      x = Math.round(x)
      y = Math.round(y)

      // Center so the popover/overlay is centered 
      var targetX = x-popoverWidth/2
      var targetY = y-popoverHeight/2

      popoverEl.style.left = `${(targetX)}px`
      popoverEl.style.top = `${targetY}px`
    },

    popoverCancelButtonClick() {
      if(this.cancelCallback) {
        this.cancelCallback(this.callbackContext, true)
      }
    },

    popoverActionButtonClick(tag, info = null) {
      if(this.actionCallback) {
        this.actionCallback(this.callbackContext, tag, info)
      }
    },

    parseToolNumber(value) {
      value = parseFloat(value || 0)
      if(isNaN(value))
        return 0
      return value
    }
  }
}